"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeMark = void 0;
const react_1 = __importDefault(require("react"));
const change_mark_styles_1 = require("./change-mark.styles");
const ChangeMark = ({ className, }) => react_1.default.createElement(change_mark_styles_1.StyledChangeMark, { className: className });
exports.ChangeMark = ChangeMark;
exports.default = exports.ChangeMark;
